// extracted by mini-css-extract-plugin
export default {"col":"styles_col__2Db-d","half":"styles_half__Ccqk6","quarter":"styles_quarter__dZ+gy","eighth":"styles_eighth__yGJgX","third":"styles_third__FMHeq","sixth":"styles_sixth__eJFw+"};